import { Button } from "react-bootstrap";
import clsx from "clsx";
import Styles from "./index.module.scss";
import { ModalInput } from "../../Atoms/InputModal";
import { formatDate, formatNumber, formatType } from "../../../Utils/index";

const formatAmount = (value) => {
  if (value == null || value === "") return "";
  const number = Number(value);
  if (Number.isNaN(number)) return value;
  return formatNumber(number);
};

const formatSafeDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return formatDate(value);
};

export default function CreateInvoiceForm({
  history,
  sepayEvent,
  isSubmitting,
  onSubmit,
}) {
  return (
    <div className={clsx(Styles.container)}>
      <div className={clsx(Styles.row)}>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Tài khoản"
            value={history?.Name || ""}
            isReadOnly
          />
        </div>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Loại"
            value={formatType(history?.Type) || history?.Type || ""}
            isReadOnly
          />
        </div>
      </div>
      <div className={clsx(Styles.row)}>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Số tiền"
            value={formatAmount(sepayEvent?.transfer_amount)}
            isReadOnly
          />
        </div>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Ngày giao dịch"
            value={formatSafeDate(sepayEvent?.transaction_date)}
            isReadOnly
          />
        </div>
      </div>
      <ModalInput
        label="Nội dung"
        value={sepayEvent?.content || ""}
        isReadOnly
      />
      <div className={clsx(Styles.row)}>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Ngân hàng"
            value={sepayEvent?.gateway || ""}
            isReadOnly
          />
        </div>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Số tài khoản"
            value={sepayEvent?.account_number || ""}
            isReadOnly
          />
        </div>
      </div>
      <div className={clsx(Styles.row)}>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Mã giao dịch Sepay"
            value={sepayEvent?.transaction_id ?? ""}
            isReadOnly
          />
        </div>
        <div className={clsx(Styles.field)}>
          <ModalInput
            label="Mã tham chiếu"
            value={sepayEvent?.reference_code || ""}
            isReadOnly
          />
        </div>
      </div>
      <div className={clsx(Styles.action)}>
        <Button
          variant="success"
          className={clsx(Styles.button)}
          disabled={isSubmitting}
          onClick={onSubmit}
        >
          {isSubmitting ? "Đang tạo..." : "Tạo hóa đơn"}
        </Button>
      </div>
    </div>
  );
}
